var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "mobile-navigation",
        class: [{ open: _vm.isMobileNavigationOpen }],
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isNavigationInitialized,
                expression: "isNavigationInitialized",
              },
            ],
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center align-items-center mheadbg",
              },
              [
                _c("div", { staticClass: "p-3 flex-f80" }, [
                  _c("img", {
                    staticStyle: { "max-height": "30px" },
                    attrs: {
                      src: `https://cdn02.plentymarkets.com/5rtbqcd0flq3/frontend/Webseite/Images/logo/stoffe-logo-${_vm.language}.webp`,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn d-flex flex-f20 align-items-center justify-content-center",
                    staticStyle: { "font-size": "18px" },
                    on: {
                      click: function ($event) {
                        return _vm.closeNavigation()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [{ name: "menu", rawName: "v-menu" }],
                staticClass: "mainmenu w-100 p-0 m-0 menu-active",
                attrs: { id: "menu-1" },
              },
              [
                _vm.dataContainer1.parent
                  ? _c(
                      "li",
                      {
                        staticClass: "ddown",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              (_vm.dataContainer1.parent &&
                                _vm.dataContainer1.parent.parent) ||
                                null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "nav-direction d-flex align-items-center mHeader",
                          },
                          [
                            _vm.selectedCat
                              ? [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-left",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex-fill text-center" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("removePrefix")(
                                              _vm.selectedCat.details[0].name
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.dataContainer1.categories, function (category) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getCategoryUrl(category.url),
                          "aria-label": "category",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("removePrefix")(category.details[0].name)
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    category.childCount
                      ? _c(
                          "span",
                          {
                            staticClass: "nav-direction",
                            on: {
                              click: function ($event) {
                                return _vm.slideTo(category)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-arrow-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ])
                }),
                _vm._v(" "),
                _vm.dataContainer1.categories[0]
                  ? _vm._l(
                      _vm.dataContainer1.categories[0].siblingCount -
                        _vm.dataContainer1.categories.length,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm.dataContainer1.parent
                  ? _vm._l(
                      _vm.dataContainer1.parent.childCount,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [{ name: "menu", rawName: "v-menu" }],
                staticClass: "mainmenu w-100 p-0 m-0",
                attrs: { id: "menu-2" },
              },
              [
                _vm.dataContainer2.parent
                  ? _c(
                      "li",
                      {
                        staticClass: "ddown",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              (_vm.dataContainer2.parent &&
                                _vm.dataContainer2.parent.parent) ||
                                null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "nav-direction d-flex align-items-center mHeader",
                          },
                          [
                            _vm.selectedCat
                              ? [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-left",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex-fill text-center" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm._f("removePrefix")(
                                              _vm.selectedCat.details[0].name
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.dataContainer2.categories, function (category) {
                  return _c("li", { staticClass: "ddown" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          "aria-label": "category",
                          href: _vm.getCategoryUrl(category.url),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("removePrefix")(category.details[0].name)
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    category.childCount
                      ? _c(
                          "span",
                          {
                            staticClass: "nav-direction",
                            on: {
                              click: function ($event) {
                                return _vm.slideTo(category)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-arrow-right",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ])
                }),
                _vm._v(" "),
                _vm.dataContainer2.categories[0]
                  ? _vm._l(
                      _vm.dataContainer2.categories[0].siblingCount -
                        _vm.dataContainer2.categories.length,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm.dataContainer2.parent
                  ? _vm._l(
                      _vm.dataContainer2.parent.childCount,
                      function (number) {
                        return _c("li", { staticClass: "ddown" }, [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ])
                      }
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        !_vm.isNavigationInitialized
          ? [
              _c(
                "ul",
                { staticClass: "mainmenu w-100 p-0 m-0 menu-active" },
                _vm._l(_vm.skeletonItemCount, function (index) {
                  return _c(
                    "li",
                    { key: "skeleton-" + index, staticClass: "ddown" },
                    [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: _vm.getRandomWidth() + "%" },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }